export const imgerror = {
  // 自定义指令
  inserted(dom, options) {
    // 钩子函数只会在初始化的时候执行
    dom.onerror = function() {
      // 当头像图片加载失败的时调用,图片路径改为默认传入的路径
      dom.src = options.value;
    };
  },
  componentUpdated(dom, options) {
    // 组件更新就会执行
    dom.src = dom.src || options.value; // 有图片就用,没有就直接使用默认的
  }
};
